import AviraLogo from "media/images/antivirusLogos/AviraLogo.png"
// import ESETLogo from "media/images/antivirusLogos/ESETLogo.png"
import KasperskyLogo from "media/images/antivirusLogos/KasperskyLogo.png"
import PandaLogo from "media/images/antivirusLogos/PandaLogo.png"
import PadvishLogo from "media/images/antivirusLogos/PadvishLogo.png"
import FSecureLogo from "media/images/antivirusLogos/FSecureLogo.png"
import BitdefenderLogo from "media/images/antivirusLogos/BitdefenderLogo.png"

const products = [
	{
		title: "نسخه خانگی",
		products: [
			{ text: "اف-سکیور", to: "/shop/f-secure" },
			{ text: "آویرا", to: "/shop/avira" },
			// { text: "ایی ست", to: "/shop/eset" },
			{ text: "بیت دیفندر", to: "/shop/bitdefender" },
			{ text: "دکتر وب", to: "/shop/dr.web" },
			{ text: "پادویش", to: "/shop/padvish" },
			{ text: "پاندا", to: "/shop/panda" },
			{ text: "کسپرسکی", to: "/shop/kaspersky" },
		],
	},
	{
		title: "نسخه موبایل",
		products: [
			// { text: "ایی ست", to: "/product/NAP-10020" },
			{ text: "بیت دیفندر", to: "/product/NAP-10021" },
			{ text: "پادویش", to: "/product/NAP-10017" },
			{ text: "پاندا", to: "/product/NAP-10011" },
			{ text: "کسپرسکی", to: "/product/NAP-10009" },
		],
	},
	{
		title: "نسخه تحت شبکه",
		products: [
			// { text: "ایی ست", to: "/shop/eset" },
			{ text: "بیت دیفندر", to: "/shop/bitdefender" },
			{ text: "کسپرسکی", to: "/shop/kaspersky" },
		],
	},
]

const logos = [
	// {
	// 	name: "ESET",
	// 	image: ESETLogo,
	// 	to: "/shop/eset",
	// },
	{
		name: "Panda3",
		image: PandaLogo,
		to: "/shop/panda",
	},
	{
		name: "Bitdefender",
		image: BitdefenderLogo,
		to: "/shop/bitdefender",
	},
	{
		name: "Avira",
		image: AviraLogo,
		to: "/shop/avira",
	},
	{
		name: "Padvish",
		image: PadvishLogo,
		to: "/shop/padvish",
	},
	{
		name: "Kaspersky",
		image: KasperskyLogo,
		to: "/shop/kaspersky",
	},
	{
		name: "F-Secure",
		image: FSecureLogo,
		to: "/shop/f-secure",
	},
	{
		name: "Bitdefender2",
		image: BitdefenderLogo,
		to: "/shop/bitdefender",
	},
	{
		name: "Avira2",
		image: AviraLogo,
		to: "/shop/avira",
	},
	{
		name: "Panda2",
		image: PandaLogo,
		to: "/shop/panda",
	},
]

export { products, logos }
